// Frame2 - Viết thiệp chúc mừng
// Logic tải ảnh tham khảo popup taiAnh/save của mulucdia/2026-sinhnhat-1tuoi (dùng dom-to-image).
import * as domtoimage from 'dom-to-image';
import bgThiepData from './bg-thiep-data.js'; // khung thiệp base64 (khỏi fetch khi chụp)

(function () {
  const frame = document.getElementById('Frame2');
  if (!frame) return;

  const card = frame.querySelector('#cardWish');
  const btnCopy = frame.querySelector('.btn-copy');
  const btnTai = frame.querySelector('.btn-taithiep');
  const btnShare = frame.querySelector('.btn-share');

  // ===== Copy Link: sao chép URL trang hiện tại =====
  if (btnCopy) {
    btnCopy.addEventListener('click', function (e) {
      e.preventDefault();
      const link = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).catch(function () {});
      }
    });
  }

  // ===== Tải Thiệp: chụp Frame2 thành ảnh PNG =====
  // dom-to-image không "chụp" được value đang gõ trong input/textarea,
  // nên tạm thay field bằng div text (giữ nguyên class/style) lúc chụp, xong khôi phục.
  function fieldToStatic(field) {
    const div = document.createElement('div');
    div.className = field.className; // giữ style theo class (vd .card-message)
    div.textContent = field.value || '';
    div.style.whiteSpace = 'pre-wrap';
    div.style.wordBreak = 'break-word';
    if (field.tagName !== 'TEXTAREA') {
      // input không có class riêng -> copy style hiển thị cần thiết
      const cs = window.getComputedStyle(field);
      div.style.width = cs.width;
      div.style.font = cs.font;
      div.style.color = cs.color;
      div.style.textAlign = cs.textAlign;
    }
    field.__captureDiv = div;
    field.style.display = 'none';
    field.parentNode.insertBefore(div, field);
  }

  function restoreField(field) {
    if (field.__captureDiv) {
      field.__captureDiv.remove();
      field.__captureDiv = null;
    }
    field.style.display = '';
  }

  if (btnTai && card) {
    btnTai.addEventListener('click', function (e) {
      e.preventDefault();
      // 1) Thay textarea -> div text để dom-to-image chụp được nội dung đang gõ
      //    (Nhân vật/Máy chủ là <span> lấy từ data nên chụp thẳng, không cần xử lý)
      const fields = Array.prototype.slice.call(card.querySelectorAll('textarea'));
      fields.forEach(fieldToStatic);

      // 2) Clone card ra ngoài màn hình, ép position:static (offset 0) để ảnh không bị lệch
      //    (.card gốc là position:absolute left/top nên chụp trực tiếp sẽ bị dịch)
      const clone = card.cloneNode(true);
      clone.style.position = 'static';
      clone.style.left = '0';
      clone.style.top = '0';
      clone.style.margin = '0';
      // Dùng nền khung base64 để dom-to-image không phải fetch ảnh (chạy cả file:// / CDN cross-origin)
      clone.style.backgroundImage = 'url("' + bgThiepData + '")';
      const holder = document.createElement('div');
      holder.style.cssText = 'position:fixed;left:-10000px;top:0;';
      holder.appendChild(clone);
      // Phải nằm trong #Frame2 để CSS "#Frame2 .card ..." vẫn áp cho clone
      frame.appendChild(holder);

      domtoimage
        .toPng(clone, {
          filter: function (node) {
            if (node.tagName === 'LINK') return false;
            if (node.className && typeof node.className === 'string') {
              return !node.className.includes('fancybox');
            }
            return true;
          },
        })
        .then(function (dataUrl) {
          const link = document.createElement('a');
          link.download = 'thiep-kiem-the-17.png';
          link.href = dataUrl;
          link.click();
        })
        .catch(function (error) {
          console.error('Lỗi khi tạo ảnh thiệp:', error);
        })
        .finally(function () {
          holder.remove();
          fields.forEach(restoreField);
        });
    });
  }

  // ===== Share Thiệp: chia sẻ link trang lên Facebook =====
  if (btnShare) {
    btnShare.addEventListener('click', function (e) {
      e.preventDefault();
      const shareUrl =
        'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(window.location.href);
      window.open(shareUrl, 'fb-share', 'width=670,height=570,menubar=no,toolbar=no');
    });
  }
})();
